const Verification = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8033 2.17216C13.2421 0.609198 10.7108 0.6092 9.14957 2.17216L8.37935 2.94324H7.04627C4.83713 2.94324 3.04627 4.7341 3.04627 6.94324V8.28223L2.17092 9.15854C0.609691 10.7215 0.609693 13.2556 2.17093 14.8185L3.04627 15.6948V17.0325C3.04627 19.2416 4.83713 21.0325 7.04627 21.0325H8.37799L9.14958 21.8049C10.7108 23.3679 13.2421 23.3679 14.8033 21.8049L15.5749 21.0325H16.9062C19.1153 21.0325 20.9062 19.2416 20.9062 17.0325V15.6953L21.782 14.8185C23.3432 13.2556 23.3432 10.7215 21.782 9.15854L20.9062 8.28181V6.94324C20.9062 4.7341 19.1153 2.94324 16.9062 2.94324H15.5735L14.8033 2.17216Z"
        fill="#00A878"
      />
      <path
        d="M8.72656 11.5567L11.1649 14.1609L15.2289 9.82056"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Verification;
